import React from 'react';
import { BaseDesktopSearchCard } from '../Base/Desktop';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import { SearchCard } from '../types';
import { GrayUIText, Title, BottomContent } from '../Base/styles';
import {
  TruckIcon,
  MapMarkerIcon,
  PhoneIcon,
  BoxConditionIcon,
} from '../../../../assets';
import { Pill } from '../../../basePill';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[2].rem};
  overflow: hidden;
`;

export const AssetForSaleDesktopSearchCard: React.FC<
  SearchCard<'AssetForSale'>
> = ({
  title,
  price,
  grayPrice,
  condition,
  location,
  isDelivery,
  data,
  type,
  ...props
}) => {
  return (
    <BaseDesktopSearchCard {...props}>
      <Content>
        <Title>{title}</Title>
        <Pill
          backgroundColor={theme.colors.neutrals.transparentGrays[6]}
          icon={PhoneIcon}
        >
          {data.pillText}
        </Pill>
        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.primary.graysGray}
            />
            {condition}
          </GrayUIText>
          <GrayUIText>
            {isDelivery ? (
              <>
                <TruckIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                Delivery
              </>
            ) : (
              <>
                <MapMarkerIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                {location}
              </>
            )}
          </GrayUIText>
        </BottomContent>
      </Content>
    </BaseDesktopSearchCard>
  );
};
